/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking401,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidOrderTracking.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentParcelsParcelidOrderTracking } from "../../clients/individualPaymentTraceabilityController/getApiV1IndividualpaymentParcelsParcelidOrderTracking.ts";

export const getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey = (
  parcelId: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
) =>
  [
    {
      url: "/api/v1/individualpayment/parcels/:parcelId/order-tracking",
      params: { parcelId: parcelId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey
  >;

export function getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryOptions(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey(
      parcelId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking401
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking500
    >,
    GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
    typeof queryKey
  >({
    enabled: !!parcelId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentParcelsParcelidOrderTracking(
        parcelId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os logs de pedido (GA_FINANCIAL_ORDER_LOG) da parcela com o tipo por extenso, mais recentes primeiro. Migrado do legado IndividualPayment/LoadParcelOrderTrackingGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna o rastreio de pedidos financeiros de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/order-tracking}
 */
export function useGetApiV1IndividualpaymentParcelsParcelidOrderTracking<
  TData = GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey,
>(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentParcelsParcelidOrderTracking401
          | GetApiV1IndividualpaymentParcelsParcelidOrderTracking500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryKey(
      parcelId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryOptions(
        parcelId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking401
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
